import React from 'react';
import { whatsapp } from 'assets/icons';
import SocialMediaButton from './SocialMediaButton';

function WhatsappButton() {
  return <SocialMediaButton imageUrl={whatsapp} to="" />;
}

export default WhatsappButton;
